import React from "react"
import { Link } from "gatsby"
import { PoweredByFlotiq } from 'flotiq-components-react';

class Footer extends React.Component {
    showCurrentYear() {
        return new Date().getFullYear();
    }
    render() {
        return (
            <footer className="site-footer">
                <div className="footer_inner">
                    <div className="container">
                        <div className="footer-widget footer-content">
                            <section id="nav_menu-8" className="widget widget_nav_menu">
                                <div className="menu-main-container">
                                    <ul id="menu-main" className="menu">
                                        <li className="nav-item">
                                            <Link to="/">Categories</Link>
                                        </li>
                                      <li className="nav-item">
                                        <Link to="/quick-search">Quick Search</Link>
                                      </li>
                                        <li className="nav-item">
                                            <Link to="/contact">Contact</Link>
                                        </li>
                                        <li className="nav-item">
                                            <a href="http://www.etsy.com/shop/PattysHomemadeGifts" target="blank" rel="noopener noreferrer">Etsy Shop</a>
                                        </li>
                                    </ul>
                                </div>
                            </section>
                        </div>
                        <div className="footer-bottom social-right-menu ">
                            <div className="location-info">
                            Chesterfield, MI
                            </div>
                            <div className="site-info">
                                ©{this.showCurrentYear()} Patty's Home Made Gifts. All rights reserved<br />
                                <br />
                                Designed & Developed by <a href="https://chrismarabate.com" target="_blank" rel="noopener noreferrer">Chris Marabate</a>
                            </div>
                        </div>
                                
                                <PoweredByFlotiq badge />
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer
